export default "__VITE_ASSET__ILqUGPoG__"